const MESSAGE_TYPE = {
  MT_UNKNOWN: 0, // 未知
  MT_TEXT: 1, // 文本
  MT_FACE: 2, // 表情
  MT_VOICE: 3, // 语音消息
  MT_IMAGE: 4, // 图片
  MT_FILE: 5, // 文件
  MT_LOCATION: 6, // 地理位置
  MT_COMMAND: 7, //7留给系统指令
  MT_VIDEO: 8, //视频
  MT_CARD: 9, //名片
  MT_BEFORE_ENTER: 10, // 询前页
  MT_TEXT_BANK: 11, //文本加银行卡
  MT_TEXT_URL: 12, //文本加URL
  MT_TEXT_PHOTO: 13, //文本加图片
  MT_TEXT_ORDER: 14, //文本加订单号
  MT_TEXT_CURRENCY: 15, //货币
  MT_QU: -1, //技能组
  MT_DRAFF: -2, //草稿
  MT_CHANNEL_TIP: -3, //本次会话
  MT_ORDER: 16, //选择订单消息
  MT_ORDER_CHECKED: 17 //确认订单
};

// 这里的 前提是 MESSAGE_TYPE 是1文本
export const MT_WELCOME_MSG = 8;

/**
 * 如果系统指令（messageType是7）
 * 在判断commandType
 */

export const COMMAND_TYPE = {
  CT_UNKNOWN: 0, // 中断会话
  CT_MATCH: 1, // 匹配到客户或者客服
  CT_TRANSFER: 2, // 会话转接
  CT_CHANNEL_TIMEOUT: 3, // 会话超时报警
  CT_FIRST_RESPONSE_TIMEOUT: 4, // 首次响应超时报警
  CT_RESPONSE_TIMEOUT: 5, // 响应超时报警
  CT_INVITE_REVIEW: 6, // 邀请评价
  CT_KICK: 7, // 强制下线
  CT_WELCOME_MSG: 8, // 欢迎语 已废弃
  CT_END_MSG: 9, // 结束语
  CT_DISCONNECT: 10, //会话超时自动关闭
  CT_ADD_BLACK: 11, // 用户被拉黑
  CT_AFTER_EVALUTATION: 12, // 客户已评价
  CT_CHANGE_STATUS: 13, // 客服状态更改 请客服端收到指令13时，自动刷新客服状态
  CT_CLOSE: 14, //客户已关闭对话框
  CT_CUSTOMER_ENTERING: 15, // 客户正在输入
  CT_CUSTOMER_CANCELENTER: 17, // 客户取消输入/ 客户输入结束
  CT_ENTERING: 16, // 客服正在输入
  CT_CANCELENTER: 18, // 客服取消输入/ 客服输入结束
  CT_QUEUECOUNT: 19, // 客户排队人数变化
  CT_CLOSEMSG: 20, //客服关闭会话 recharge
  CT_UPDATERE_CHARGECODE: 22, //代客充值码 更新
  CT_NOTICE_MESSAGE: 29, //通知
  CT_ONE_MINUTE_NO_RESPONSE: 24, //代表会话一分钟客服客户未响应指令
  CT_SNATCH_CONVERSATION_IN: 25, //抢接接入会话指令
  CT_SNATCH_CONVERSATION_OUT: 26, //抢接转出会话指令
  CT_FIRST_RESPONSE_TIMEOUT_answered: 27, //首响已回复
  CT_ISCHECK_ORDER: 28 //客户点击是的 服务器发送的系统消息
};

export const CLOSE_COMMANDS = [
  COMMAND_TYPE.CT_KICK,
  COMMAND_TYPE.CT_DISCONNECT,
  COMMAND_TYPE.CT_CLOSE,
  COMMAND_TYPE.CT_SNATCH_CONVERSATION_OUT,
  COMMAND_TYPE.CT_CLOSEMSG
];

export const COMMAND_TYPE_CONTENT = {
  [COMMAND_TYPE.CT_UNKNOWN]: "未知指令",
  [COMMAND_TYPE.CT_MATCH]: "与客服小仙女创建对话",
  [COMMAND_TYPE.CT_TRANSFER]: "",
  [COMMAND_TYPE.CT_CHANNEL_TIMEOUT]: "", // 会话超时报警
  [COMMAND_TYPE.CT_FIRST_RESPONSE_TIMEOUT]: "", // 首次响应超时报警,
  [COMMAND_TYPE.CT_RESPONSE_TIMEOUT]: "", // 响应超时报警,
  [COMMAND_TYPE.CT_INVITE_REVIEW]: "邀请客户评价",
  [COMMAND_TYPE.CT_KICK]: "", //强制下线
  [COMMAND_TYPE.CT_WELCOME_MSG]: "欢迎语",
  [COMMAND_TYPE.CT_END_MSG]: "",
  [COMMAND_TYPE.CT_DISCONNECT]: "会话超时自动关闭",
  [COMMAND_TYPE.CT_ADD_BLACK]: "", //黑名单
  [COMMAND_TYPE.CT_CHANGE_STATUS]: "客服状态已变更", //客服状态已变更
  [COMMAND_TYPE.CT_AFTER_EVALUTATION]: "客户已评价完成",
  [COMMAND_TYPE.CT_CLOSE]: "客户关闭对话框",
  [COMMAND_TYPE.CT_COUNT]: "用户排队总数",
  [COMMAND_TYPE.CT_CLOSEMSG]: "客服已关闭对话" //客服关闭会话
  // [COMMAND_TYPE.CT_CUSTOMER_ENTERING]: "客户正在输入",
  // [COMMAND_TYPE.CT_CUSTOMER_CANCELENTER]: "客户取消输入/ 客户输入结束",
  // [COMMAND_TYPE.CT_ENTERING]: "客服正在输入",
  // [COMMAND_TYPE.CT_CANCELENTER]: "客服取消输入/ 客服输入结束"
};

const testAccount = {
  defaultPhoto: require("src/assets/imgs/server-avatar.jpg"),
  customer: {
    userId: process.env.VUE_APP_CUSTOMER_ID,
    userName: process.env.VUE_APP_CUSTOMER_NAME,
    type: 2,
    chatType: 0
  },
  workbench: {
    userId: 3335058432666,
    userName: "kefu01",
    type: 3,
    chatType: 0
  }
};

const SOCKET_ERR_MSG = {
  0: "连接成功",
  101: "上报消息的包类型不再packagetype类型中",
  102: "无法解析消息",
  103: "消息内容为空",
  104: "消息类型不合法",
  201: "token不合法，服务端解析失败",
  202: "token不存在",
  210: "设备登录通过后，挤掉其他在线同类型设备",
  211: "系统强制设备下线",
  212: "未知错误"
};

export const TOURIST_TYPE = 2;

export const ML_URL = {
  pcNoParams: "https://www.m6vip2.com/",
  h5NoParams: "https://m.m6vip2.com/",
  pc: `https://www.m6vip2.com/?backurl=${window.location.host}/login`,
  h5: `https://m.m6vip2.com/signIn?backurl=${window.location.host}/login`,
  pcHelpCenter: "https://www.m6vip2.com/about-us/deposit",
  h5HelpCenter: "https://m.m6vip2.com/help-center"
};

// export const PRODUCTID = "ml";

export const VERSION = 175;

const fk = "2020&seektop-kefu";

export default {
  MESSAGE_TYPE,
  MT_WELCOME_MSG,
  COMMAND_TYPE,
  COMMAND_TYPE_CONTENT,
  SOCKET_ERR_MSG,
  testAccount,
  TOURIST_TYPE,
  ML_URL,
  VERSION,
  // PRODUCTID,
  fk,
  CLOSE_COMMANDS
};
